import gql from 'graphql-tag'

// CAW_PRODUCT: '3',
// CAW_TEMPLATE: '4',
// CAW_EMPLOYEE: '5',
// CAW_MEDIA_CENTER: '6',
// CAW_CUSTOMERS_CREDIT: '12',
// CAW_DEGREES: '9',
// CAW_DEBIT_CARD: '13',
// CAW_STATISTICS: '11',
// CAW_MESSAGES: '14',
// CAW_OPTIONS: '1',
// CAW_DASHBOARD: '99'

export default gql`
	extend type Query {
		getClientPriceLevels(onlyActive: Boolean): [String]
	}
`
